// extracted by mini-css-extract-plugin
module.exports = {"tick":"styles_tick__13ZFi"};